<template>
  <div class="full">
    <div class="back" @click="goback()">返回首页</div>
    <div class="back-to-top" @click="scrollToTop" v-show="isAtTop">
      返回顶部
    </div>

    <div class="box">
      <h1>{{ bigTitle }}</h1>
      <div class="menu">
        <div class="tab">
          <div class="nav" id="box2nav">
            <div
              v-for="(item, index) in box2TabData"
              :key="index"
              @click="(box2TabIndex = index), getQaDatas()"
            >
              <a :class="box2TabIndex == index ? 'checked' : 'tab-item'">{{
                item
              }}</a>
            </div>
          </div>
        </div>

        <div class="input">
          <input
            class="edit"
            v-model="searchKeyWords"
            type="text"
            placeholder="请输入检索词"
            @keyup.enter="getQaDatas()"
          />
          <div @click="getQaDatas()" class="btn">
            <img src="../assets/images/shencha/search_big.svg" alt="" />
          </div>
        </div>
      </div>

      <div
        v-for="(item, index) in listDatas[currentPage - 1]"
        :key="index"
        class="item"
        @click="goHangyeDetailPage(item)"
      >
        <div class="leftbox">
          <div class="q">
            {{ index + ((currentPage - 1) * 10 + 1) + "." + item["question"] }}
          </div>
          <div class="source">答复部门：{{ item["source"] }}</div>
        </div>
        <div class="rightbox">
          答复时间： {{ formatDate(item["publicTime"]) }}
        </div>
      </div>
    </div>

    <div class="fanye">
      <el-pagination
        v-model:current-page="currentPage"
        :page-size="currentSizeNum"
        layout="total, prev, pager, next"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getParams();
  },
  data() {
    return {
      searchKeyWords: "",
      box2TabIndex: 0, //默认选中0
      fromIndex: 1, //默认为1，不定位到问答模块
      isVisible: "false",
      scrollThreshold: 800,
      keyword: "",
      currentPage: 1,
      currentSizeNum: 10,
      totalCount: 0,
      bigTitle: "合规问答",
      index: 0,
      listDatas: [
        [
          {
            question:
              "国有控股企业其主营业务为某类资产的租赁和销售服务，这个国有控股企业采购该类拟用于租赁、售卖的资产时是否需要履行招投标程序？国有控股企业处置（包含销售）租赁物、售卖主营涉及的资产时是否适用《企业国有资产交易监督管理办法》，需要进场交易？",
            answer:
              "您好：您在我们网站上提交的问题已收悉，现针对您所提供的信息简要回复如下：国有企业日常生产经营活动过程中，销售原材料、在产品、半成品、产成品等存货的行为不属于32号令的规范范围，不需通过产权交易机构公开挂牌。如国有房地产开发企业销售自行开发的不动产属于企业日常经营活动，该种行为不属于32号令规范的范畴，不需要进场交易，可按照行业惯例方式进行销售。如相关物业列入转让方的固定资产，该等固定资产的转让行为应按照32号令的相关规定履行进场交易程序。上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2023/10/19",
          },
          {
            question:
              "外购免税产品无偿赠送，是否属于视同销售，是否需要缴纳增值税？",
            answer:
              "  根据《中华人民共和国增值税暂行条例实施细则》（财政部 国家税务总局令第50号）的规定：第四条单位或者个体工商户的下列行为，视同销售货物：（一）将货物交付其他单位或者个人代销；（二）销售代销货物；（三）设有两个以上机构并实行统一核算的纳税人，将货物从一个机构移送其他机构用于销售，但相关机构设在同一县（市）的除外；（四）将自产或者委托加工的货物用于非增值税应税项目；（五）将自产、委托加工的货物用于集体福利或者个人消费；（六）将自产、委托加工或者购进的货物作为投资，提供给其他单位或者个体工商户；（七）将自产、委托加工或者购进的货物分配给股东或者投资者；（八）将自产、委托加工或者购进的货物无偿赠送其他单位或者个人。上述回复仅供参考。",
            source: "国家税务局",
            date: "2021/7/13",
          },
          {
            question:
              "国家发改委发的16号令规定：400万元以上的建设工程项目必须公开招标，但400万元以下的工程项目如何发包，没有规定。问：招标人是否可以直接发包，或者按财政采购的有关法律规定，采用竞争性谈判和竞争性磋商等方式发包？",
            answer:
              "您好，《进一步做好<必须招标的工程项目规定>和<必须招标的基础设施和公用事业项目范围规定>实施工作的通知》（发改办法规〔2020〕770号）规定，《必须招标的工程项目规定》（2018年第16号令，以下简称16号令）第二条至第四条及《必须招标的基础设施和公用事业项目范围规定》（发改法规规〔2018〕843号）第二条规定范围的项目，其施工、货物、服务采购的单项合同估算价未达到16号令第五条规定规模标准的，该单项采购由采购人依法自主选择采购方式，任何单位和个人不得违法干涉；其中，涉及政府采购的，按照政府采购法律法规规定执行。感谢您对发展改革工作的关心和支持！",
            source: "国家发改委",
            date: "2021/1/25",
          },
          {
            question:
              "1、用地沟油、潲水油等废弃动植物油脂通过加氢反应生产C14-C18的饱和烷烃作为燃料添加到柴油中使用的生产企业应属于哪类行业（化工、能源、环资、综合利用）？2、在《产业结构调整指导目录(2019年本)》中此行业应选对应项是那一条？3、审批备案应归属那个部门？4、审批级别应该是哪一级？",
            answer:
              "您好，“地沟油、潲水油等废弃动植物油脂通过加氢反应生产C14-C18的饱和烷烃”符合《产业结构调整指导目录（2019年本）》鼓励类“四十三、环境保护与资源节约综合利用”中“27、废旧木材、废旧电器电子产品、废印刷电路板、废旧电池、废旧船舶、废旧农机、废塑料、废旧纺织品及纺织废料和边角料、废（碎）玻璃、废橡胶、废弃油脂等废旧物资等资源循环再利用技术、设备开发及应用”的要求。项目立项或备案建议您咨询当地发展改革部门。感谢您对国家发展改革委工作的关心和支持！",
            source: "国家发改委环资司",
            date: "2022/5/24",
          },
          {
            question:
              "推动实现碳达峰、碳中和，国资央企具体应该从哪些方面如何去做？",
            answer:
              "您好：    您在我们网站上提交的问题已收悉，现根据国资委有关负责人详解“十四五”国资国企改革发展新看点的相关内容，针对您所提供的信息简要回复如下：    实现碳达峰、碳中和目标对中央企业是挑战，更是机遇。国资央企将把碳达峰、碳中和纳入企业发展整体布局，坚定不移走生态优先、绿色低碳的高质量发展道路。    加快发展方式绿色转型。深入打好污染防治攻坚战，坚决遏制“两高”项目盲目发展，提升能源资源利用效率和清洁生产水平，以绿色低碳新技术、新模式、新业态大力推动企业业务结构优化升级。    大力发展绿色低碳产业。积极发展节能环保、清洁生产、清洁能源、生态环境、绿色农业、绿色建筑、绿色服务等产业，推进基础设施绿色升级，加强碳资产管理，打造产业生态体系，引领产业提质增效。    全面提高能源资源利用效率。引导企业优先使用绿色低碳能源，深化工业、建筑、交通运输等重点领域节能，提升数据中心、新型通讯等信息化基础设施能效水平，淘汰落后设备工艺，加快建立循环型生产体系。    上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2021/8/4",
          },
          {
            question:
              "新颁布的“企业标准化促进办法”中第十二条规定，试验方法、检验方法或者评价方法应当引用相应国家标准、行业标准或者国际标准。请问这里的国际标准该如何界定或定义？其他国家的标准如美国的AATCC、ASTM，日本的JIS等标准，是否是国际标准？谢谢。",
            answer:
              "国际标准是指国际标准化组织（ISO）、国际电工委员会（IEC）和国际电信联盟（ITU）制定的标准，以及其他公认的国际组织制定的标准。按照上述定义，AATCC、ASTM以及日本的JIS等标准，其制定主体不是国际标准化组织，不能算是国际标准。",
            source: "国家市场监督管理总局",
            date: "2023/12/11",
          },
          {
            question:
              "《汽车零部件再制造规范管理暂行办法》第23条中规定，使用再制造产品用于维修时，需要向消费者说明产品为再制造产品。如果是在汽车三包期内，售后维修不需要消费者支付费用，也就是说，无论厂家使用的是全新产品，还是再制造产品，都不需要消费者付费，厂家负担全部成本。1、上述三包期内的情形，（即消费者无需付费），是否可以免除厂家和4S店的告知义务？2、向消费者告知后，若消费者不同意使用再制造产品，厂家和4S店是否必须征得消费者同意之后才可以使用再制造品？谢谢。",
            answer:
              "您好，1.《汽车零部件再制造规范管理暂行办法》第二十三条规定“再制造产品销售企业、汽车维修企业在销售和使用再制造产品时应向消费者说明产品为再制造产品，并提供再制造产品的质量合格证明、质量保证信息和售后质量保修手册”。在无需消费者付费情形下，也不应免除告知义务。2.《汽车零部件再制造规范管理暂行办法》第二十六条规定“国家倡导消费者使用再制造产品”。《家用汽车产品修理更换退货责任规定》第十六条规定“包修期内修理者用于修理的零部件应当是生产者提供或者认可的合格零部件，并且其质量不得低于原车配置的零部件质量”。在具体维修过程中，应当尊重消费者意愿。如无法达成一致发生消费纠纷，建议咨询市场监管部门。感谢您对国家发展改革委工作的关心和支持！",
            source: "发改委环资司",
            date: "2022/5/31",
          },
          {
            question:
              "我所在的工地集体按项目参加了工伤保险。我想问在工期里，受伤了怎么赔呢？能够享受正常的工伤待遇么？",
            answer:
              "按项目参加工伤保险的工程建设项目，工伤保险覆盖项目使用的包括劳务派遣公司、专业分包公司等在内的所有职工。职工在工程建设项目受到事故伤害，可以向工程建设项目所在地统筹地区社会保险行政部门提出工伤认定申请；经认定为工伤的，依法享受《工伤保险条例》规定的相应待遇。",
            source: "人社部",
            date: "2018/11/14",
          },
        ],
        [
          {
            question:
              "合同到期后，不打算续签合同了，如果暂时没有找到合适的单位，请问我如何缴纳社保？",
            answer:
              "    参保人员再次就业前，可以选择以灵活就业人员身份参加职工养老保险，或以居民身份在户籍地参加城乡居民养老保险。",
            source: "人社部",
            date: "2018/11/4",
          },
          {
            question: "国债工作什么时间开始利息是多少？",
            answer:
              "感谢您对国债发行工作的关心。根据《关于公布2023年第四季度国债发行计划的通知》（财办库〔2023〕190号），近期计划发行的储蓄国债发行起始日为11月10日。具体利率将在国债业务公告中公布。您可关注财政部网站“政府债券管理”专题（网址：gks.mof.gov.cn/ztztz/guozaiguanli/）公布的国债发行计划和各期次国债业务公告，及时获取相关信息。 ",
            source: "财政部",
            date: "2023/11/21",
          },
          {
            question:
              "您好，请问，一家道路运输企业的营运车辆，在进行车辆年检的时候所产生的费用能不能算入企业的安全生产投入中？",
            answer:
              " 感谢您对财政资产工作的关心与支持。关于您咨询的问题，办法第二十五条明确了交通运输企业安全生产费用支出的范围，与安全生产不直接相关的支出不在该范围内。",
            source: "财政部",
            date: "2023/7/4",
          },
          {
            question:
              " 您好，想咨询下在国有企业正常经营过程中，（1）国有独资企业是否可以向自己投资的合资企业借款，有无相关文件规定，操作流程规范如何？（2）国有独资企业是否可以对外借款，如民营企业等，有无相关文件规定，操作流程规范如何？（3）国有独资企业之间是否可以互相拆解资金，如无相关规定可以参考？",
            answer:
              "您好：        您提出的关于国有企业借款的问题收悉。经研究，现答复如下：        《关于加强中央企业资金管理有关事项的补充通知》（国资厅发评价〔2012〕45号）规定，中央企业禁止对集团外企业拆借资金；中央企业要审慎开展对集团外企业委托贷款业务，委托贷款对象应当选择资信良好、有业务关系且具备偿还能力的大型企业，其中对中央企业之外的企业或单位还应当事先报国资委备案。　       上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2021/12/8",
          },
          {
            question:
              "您好，由于不具备专利法第22条第3款规定的创造性，如何申请撤回？如何申请退还50%的专利申请实质审查费?",
            answer:
              "您好：    授予专利权之前，申请人随时可以主动要求撤回其专利申请。申请人撤回专利申请的，应当提交《撤回专利申请声明》，并附具全体申请人签字或者盖章同意撤回专利申请的证明材料，或者仅提交由全体申请人签字或者盖章的《撤回专利申请声明》。委托专利代理机构的，撤回专利申请的手续应当由专利代理机构办理，并附具全体申请人签字或者盖章同意撤回专利申请的证明材料。    撤回专利申请不得附有任何条件。    撤回专利申请的声明是在专利申请进入公报编辑后提出的，申请文件照常公布或者公告，但审查程序终止。纸质申请的撤回专利申请声明邮寄地址：北京市海淀区蓟门桥西土城路6号国家知识产权局专利局受理处，邮编：100088。    如专利为电子申请，则需要提交电子文件。",
            source: "国家知识产权局",
            date: "2023/11/17",
          },
          {
            question:
              "公司变更组织形式，如从**有限责任公司变更为**股份有限公司，商标应该交名称变更还是交商标移转申请？",
            answer:
              "您好：    收到您的留言，根据《商标法》第四十一条和《商标法实施条例》第十七条、第三十条的规定，注册商标需要办理变更注册人的名义、地址或者其他注册事项的，应当提出变更申请。申请人已经提交注册申请但尚未获准注册的，其名义、地址或者其他注册事项发生变更的，应当向国家知识产权局申请办理相应的变更手续。   因继承、企业合并、兼并或改制等发生商标专用权移转的，应当办理移转手续。",
            source: "国家知识产权局",
            date: "2023/11/17",
          },
          {
            question: "国资委打算如何跟外企合作达到共赢？",
            answer:
              "您好：    您在我们网站上提交的问题已收悉，现根据彭华岗同志通报2019年上半年中央企业经济运行情况时的有关讲话内容，针对您所提供的信息简要回复如下：    国资委这么多年和国际上这些大的跨国公司，包括通用电气这样的企业，都有良好的交往和合作，通用电气和我们很多央企都有实质性的业务合作。中央企业在发展过程中，不光是在国内也好或者是“走出去”也好，都和这些国际大型的跨国公司有非常良好的合作，既有共同开展的项目合作，也有国内的一些合资企业的合作，这些合作对于推动中央企业发展起到了积极的作用。当然，这些国际大型跨国公司也非常愿意和我们的企业加强合作，国资委也明确表示支持鼓励这种合作。　  上述回复仅供参考。欢迎您再次提问。",
            source: "国务院国资委",
            date: "2019/7/24",
          },
          {
            question:
              "如何推动中央企业与各国企业促进共建“一带一路”迈上新台阶？",
            answer:
              "您好：您在我们网站上提交的问题收悉，现针对您所提供的信息简要回复如下：     目前中央企业共承担“一带一路”建设项目3120个。在参与“一带一路”建设中，中央企业更加注重把高质量发展要求融入项目建设，更加注重引领和带动当地经济发展，更加注重强化优势互补与协同合作，更加注重建设民生工程让当地居民受益，更加注重环境保护和资源节约。通过参与共建“一带一路”，中央企业加快了自身国际化进程，在促进全球化进程中发挥了重要作用。      国资委和中央企业将认真贯彻落实习近平主席在“一带一路”峰会上的重要讲话精神，一步一个脚印推进“一带一路”项目实施，一点一滴抓出共建“一带一路”高质量发展成果。进一步契合当地发展需求，因地制宜开展合作建设；进一步强化项目管理，高标准高质量打造精品示范工程；进一步拓展合作空间，努力实现互利共赢共同发展；进一步模范履行社会责任，做优秀的企业公民，为当地经济社会发展作出应有贡献。　  上述回复仅供参考。欢迎您再次提问。",
            source: "国务院国资委",
            date: "2019/4/28",
          },
        ],
        [
          {
            question:
              "问题一：请问如果A公司为中外合资的有限责任公司。其股东中，国资股东持股比例与外方股东持股比例相同，都为40，且同为最大股东。那么该公司的实际控制人是谁？我们该如何定义公司的国有属性？问题二：B公司作为A公司旗下的上市公司，A公司为B公司的第一大股东。那么作为上市公司的B公司是否需要有国有企业标识？",
            answer:
              "您好：        您在我们网站上提交的问题已收悉，现针对您所提供的信息简要回复如下：        一、根据《企业国有资产交易监督管理办法》（国资委 财政部令第32号）第四条，按照公司股权结构，结合投资关系、股东协议、公司章程、是否存在一致行动人或其他协议安排等情况进行综合判定，国有股东能够对公司的战略规划、经营决策等行为进行实质性支配控制和有效贯彻，且足以对股东会、董事会决议产生重大影响，即可证明国有企业对标的企业拥有实际控制权。        二、按照《关于进一步明确非上市股份有限公司国有股权管理有关事项的通知》（国资厅产权〔2018〕760号）第三条，非上市股份有限公司拟首次在证券交易所申请发行股票并上市，其股东符合《上市公司国有股权监督管理办法》（国资委 财政部 证监会令第36号）第三条和第七十四条所规定情形的，由国有资产监督管理机构进行标识管理。        上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2023/10/24",
          },
          {
            question:
              "在一家国有控股公司中，如果非国资股东转让股份给国资股东，请问这种情形下需要进场公开交易吗？2021/7/21",
            answer:
              " 您好：        您在我们网站上提交的问题已收悉，现针对您所提供的信息简要回复如下：        根据《企业国有资产交易监督管理办法》（国资委 财政部令第32号，以下简称32号令）第三条第一款，企业产权转让是指履行出资人职责的机构、国有及国有控股企业、国有实际控制企业转让其对企业各种形式出资所形成权益的行为。32号令中企业产权转让行为规范的主体是转让方，即转让方是履行出资人职责的机构、国有及国有控股企业、国有实际控制企业的，其转让所持企业股权应当按照32号令相关规定进场交易。因此，非国有股东转让所持国有企业股权的行为不属于32号令的规范范畴。　        上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2023/10/9",
          },
          {
            question:
              "目前，融资性贸易在国资监管中的描述为禁止开展“名为贸易实为借贷”的融资性贸易，没有查询到详细的界定标准。在各级地方国资监管部门和国有企业执行时，标准不一，争议不断。贸易大多有回款账期存在资金实质性占用，如何与正常的贸易流通或供应链业务区分？",
            answer:
              " 您好：        您在我们网站上提交的问题已收悉，现针对您所提供的信息简要回复如下：        《关于进一步排查中央企业融资性贸易业务风险的通知》（国资财管〔2017〕652号）规定，融资性贸易业务是以贸易业务为名，实为出借资金、无商业实质的违规业务。其表现形式多样，具有一定的隐蔽性，主要特征有：一是虚构贸易背景，或人为增加交易环节；二是上游供应商和下游客户均为同一实际控制人控制，或上下游之间存在特定利益关系；三是贸易标的由对方实质控制；四是直接提供资金或通过结算票据、办理保理、增信支持等方式变相提供资金。        上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2023/2/7",
          },
          {
            question:
              "请问民爆行业及新能源发电行业是否属于安全审查范围？若属于安全审查范围，该如何审查？相关接洽部门是哪里？该如何递交材料？谢谢！",
            answer:
              "您好，《外商投资安全审查办法》涉及场景众多且具体，请您直接咨询办公电话010-68501622、68502979。感谢您对发展改革工作的关心和支持！",
            source: "国家发改委外资司",
            date: "2020/12/24",
          },
          {
            question: "如何确保中央企业安全生产？",
            answer:
              "您好：    您在我们网站上提交的问题已收悉，现针对您所提供的信息简要回复如下：    4月15日，国资委与应急管理部联合召开中央企业安全生产工作视频会议。    会议要求,中央企业要提高政治站位、强化责任担当，防范化解复工复产过程中的安全风险，认真开展安全生产专项整治三年行动，持续夯实安全生产管理基础，提高各类突发事件应  对处置能力，提升安全生产管理水平，推动安全生产形势持续稳中向好。    会议强调，中央企业要进一步增强“四个意识”、坚定“四个自信”、做到“两个维护”，把初心落在行动上，把使命担在肩膀上，以对党和人民高度负责的精神，沉下心来、扑下身子，继续毫不放松抓好安全生产和疫情防控各项工作，为打赢疫情防控阻击战、奋力实现经济社会发展目标作出贡献。    上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2020/4/27",
          },
          {
            question: "中央企业安全生产和应急管理工作进展如何？",
            answer:
              "您好：    您在我们网站上提交的问题收悉，现针对您所提供的信息简要回复如下：    党的十八大以来，中央企业深入贯彻习近平新时代中国特色社会主义思想，以总体国家安全观为指引，坚决落实党中央、国务院决策部署，不断完善应急管理体系，大力推进改革创新，认真履行社会责任，中央企业安全生产和应急管理工作取得明显成效。中央企业正处于从注重规模向注重质量和效益转变，从产业链中低端向价值链的高端转变，从以国内市场为主向注重国际化经营转变的过程中，一些深层次矛盾和风险逐渐显现。中央企业应急管理工作面临着新的形势，要正视新的变化、新的问题。国资委和中央企业将继续坚持以人为本、安全发展理念，科学筹划，狠抓落实，促进应急管理工作再上新台阶。    上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2018/12/13",
          },
          {
            question:
              "中央企业网络安全和信息化工作的整体思路和工作重点是什么？",
            answer:
              "您在我们网站上提交的问题已收悉，根据徐福顺在2017年中央企业网络安全和信息化工作会议上的讲话，现针对您所提供的信息简要回复如下：  1、整体思路：深入贯彻落实党的十九大精神，认真学习贯彻习近平新时代中国特色社会主义思想，牢固树立新发展理念，以深化供给侧结构性改革为主线，以信息技术和企业生产经营深度融合为重点，以网络安全为保障，强化创新、加强协同，全面提升网信水平，加快建设“数字企业”，推动企业向“智慧企业”迈进，加快转型升级提质增效，培育具有全球竞争力的世界一流企业。   2、工作重点：一是进一步健全网信管理体系和工作机制；二是进一步加强集团统筹和管控；三是着力加强信息技术与生产经营深度融合；四是持续强化网络安全防护；五是进一步加强网信协同发展。　上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2017/12/11",
          },
          {
            question:
              "目前有多家药企将产品做进医院，现举例说明：1、某即将进入集采的非甾体抗炎药通过医药公司配送（配送价格57），每月底在医药公司调取数量结算，以每支17元进行返利打入医院私户，同时按医生职称高低申请讲课费、学术会、赞助费等名目费用给与医院、个人。2、已在集采目录的氟喹诺酮类五官用药更是以厂家直接发货的形式进行上述同种操作（返利不同）。请问这属于不正当竞争？商业贿赂？另外补充几点：1、如果将返利打入同时医院公户和个人私户怎么算？2、对于药企的上述行为是由哪个部门进行日常监督管理？请与解答回复，谢谢。",
            answer:
              "商业贿赂属于不正当竞争行为的其中一种，一般情况下由市场监管部门监管，法律、行政法规规定由其他部门查处的，依照其规定。《反不正当竞争法》第七条规定，经营者不得采用财物或者其他手段贿赂下列单位或者个人，以谋取交易机会或者竞争优势： （一）交易相对方的工作人员； （二）受交易相对方委托办理相关事务的单位或者个人； （三）利用职权或者影响力影响交易的单位或者个人。 经营者在交易活动中，可以以明示方式向交易相对方支付折扣，或者向中间人支付佣金。经营者向交易相对方支付折扣、向中间人支付佣金的，应当如实入账。接受折扣、佣金的经营者也应当如实入账。 经营者的工作人员进行贿赂的，应当认定为经营者的行为；但是，经营者有证据证明该工作人员的行为与为经营者谋取交易机会或者竞争优势无关的除外。 请您根据以上规定，判断您所要了解的行为是否构成商业贿赂。如掌握具体线索或证据，请根据属地管理原则，选择相应地方市场监管部门举报。市场监督管理部门投诉举报电话为“12315”。",
            source: "国家市场监督管理总局",
            date: "2022/9/19",
          },
        ],
        [
          {
            question:
              "西安市锦裕霖航空科技有限公司，注册资本1000万，实缴资本1000亿，巨额财产来源不明，涉嫌偷税漏税，希望市场监督管理局可以解决。",
            answer:
              "现行反不正当竞争法第七条规定： 经营者不得采用财物或者其他手段贿赂下列单位或者个人，以谋取交易机会或者竞争优势： （一）交易相对方的工作人员； （二）受交易相对方委托办理相关事务的单位或者个人； （三）利用职权或者影响力影响交易的单位或者个人。 经营者在交易活动中，可以以明示方式向交易相对方支付折扣，或者向中间人支付佣金。经营者向交易相对方支付折扣、向中间人支付佣金的，应当如实入账。接受折扣、佣金的经营者也应当如实入账。 经营者的工作人员进行贿赂的，应当认定为经营者的行为；但是，经营者有证据证明该工作人员的行为与为经营者谋取交易机会或者竞争优势无关的除外。 您咨询的问题或者反映的情况不属于反不正当竞争法规制的商业贿赂违法行为，也不属于其他类型不正当竞争行为。请您核实后重新选择留言类型留言或向其他有关部门咨询反映。",
            source: "国家市场监督管理总局",
            date: "2022/9/13",
          },
          {
            question:
              "国家垄断局工作人员你们好，针对近期社会上热议的关于蔚来新疆充电桩事件想问下这种按照品牌车型给予某时间段充电的情况是否涉及垄断谢谢。",
            answer:
              "您好！您的留言收悉。我国《反垄断法》禁止具有市场支配地位的经营者实施滥用市场支配地位行为。相关经营者的行为是否违反《反垄断法》，需要反垄断执法机构基于调查取证、研究分析后依据法定程序作出判定。对于您反映的问题，在未开展调查、取证、分析等执法程序的情况下，难以认定相关行为是否违法。感谢您对反垄断工作的关注和支持！",
            source: "国家市场监督管理总局",
            date: "2023/7/28",
          },
          {
            question:
              "请问民办非营利社区卫生服务站 药品定价是采用自主定价还是必须全部采用基本药物注：民办，无编制，全部自负盈亏，部分基本药物零差价销售，国家有基本药物补助，其他有关药品方面无补助。",
            answer:
              "目前，除麻醉药品和第一类精神药品由药品价格主管部门制定价格以外，其他药品价格由经营者自主制定。",
            source: "国家市场监督管理总局",
            date: "2023/3/17",
          },
          {
            question:
              "国资央企该从哪几方面推进科技自立自强，夯实“三个转变”战略支撑？具体应该怎么做？",
            answer:
              "您好：您在我们网站上提交的问题已收悉，现根据国务院国有资产监督管理委员会党委委员、副主任翁杰明刊发《学习时报》署名文章《强化创新引领 加快“三个转变” 更好推动中国制造高质量发展》的主要精神，针对您所提供的信息简要回复如下：围绕推动高质量发展、构建新发展格局，坚持把科技创新作为“头号任务”，大力实施创新驱动发展战略，持续加大研发投入力度，优化研发支出结构，不断强化国家战略科技力量。一是努力打造科技攻关重地，积极与国家攻关计划对接，针对工业母机、高端芯片、基础软件、新材料、大飞机、发动机等产业薄弱环节，联合行业上下游、产学研力量开展协同攻关，发挥创新联合体优势作用，进一步把最优秀的人才、最急需的资源、最先进的设备集中配置到攻关任务上来，在解决“卡脖子”问题上实现更多更大突破。二是努力打造原创技术“策源地”，积极融入国家基础研究创新体系，主动承担重大项目，进一步加大原创技术研发投入，在信息、生物、能源、材料等方向，加快布局一批基础应用技术；在人工智能、空天技术、装备制造等方面，加快突破一批前沿技术；在电力装备、通信设备、高铁、核电、新能源等领域，加快锻造一批长板技术，不断增强行业共性技术供给。三是努力打造科技创新“特区”，深入落实激励机制，坚持特殊人才特殊激励，对重点科研团队一律实行工资总额单列，对科技人才实施股权和分红激励等中长期激励政策，建设更多高水平研发平台和新型研发机构，赋予科研人员更大自主权、给予更大容错空间，在中央企业形成创新创业浓厚氛围。上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2021/6/3",
          },
          {
            question: "如何进一步提升中央企业科技创新实力？具体有什么措施？",
            answer:
              "您好：您在我们网站上提交的问题已收悉，现根据《学习时报》刊发国务院国资委党委书记、主任郝鹏署名文章《充分发挥国有经济战略支撑作用》的相关内容，针对您所提供的信息简要回复如下：国务院国资委将科技创新作为“头号任务”，集中资源、集中力量，坚决把中央企业打造成为国家战略科技力量。努力打造科技攻关重地，针对产业薄弱环节，组建创新联合体，尽快解决“卡脖子”问题。努力打造原创技术策源地，加大原创技术研发投入，布局一批基础应用技术，突破一批前沿技术，锻造一批长板技术。努力打造科技人才高地，培养急需紧缺的科技领军人才和高水平创新团队，坚持特殊人才特殊激励，激发创新创造活力。努力打造科技创新“特区”，在政策支持上坚决做到能给尽给、应给尽给，积极推行科研项目“揭榜挂帅”、项目经费“包干制”新型管理模式，营造良好创新环境。上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2021/3/19",
          },
          {
            question:
              "今年6月末，中央企业的资产负债率为64.9%，同比下降1个百分点。请问接下来在防范化解重大风险方面，国资委有哪些考虑？尤其在防范国企债券违约风险方面有哪些具体的举措？",
            answer:
              "您好：您在我们网站上提交的问题已收悉，现根据2021年上半年央企经济运行情况新闻发布会上答记者问的有关内容，针对您所提供的信息简要回复如下：防范化解风险的问题是国资委和中央企业非常重视的问题，6月末中央企业的资产负债率是64.9%，同比下降了1个百分点，总体上保持稳定，债务风险整体可控。近几年，中央企业没有发生一起债券违约的事件。下一步的工作，要继续做好中央企业的债务风险管控，主要有以下几个方面：一是要管住负债率。按照行业制定警戒线、管控线，然后实施分类管控，一企一策，确定负债率的年度目标并跟踪落实，保持中央企业整体负债水平稳定。二是要管住重点企业。要加强债务风险动态监测，通过债务风险量化评估体系精准地识别高风险企业，采取特别的监管措施，一企一策化解处置。三是要管住高风险业务。要严管非主业低毛利大宗商品贸易这种业务风险，严控金融衍生、融资担保、PPP等业务风险，坚决禁止开展融资性贸易业务。在防范债券风险方面，建立一套中央企业的债券风险防范机制。一是严格债券发行的比例限制，严控高风险企业债券占带息负债比例和短期债券占债券的比例，防止出现集中兑付的风险。二是严格债券资金用途，聚焦主业实业，严禁资金空转、脱实向虚，严禁挪用资金违规套利。发债券是投向主业、实业，严禁用到其它地方。三是加强债券风险监测，重点关注经营严重亏损、现金流紧张企业的债券违约风险，提前做好兑付资金安排。四是要建立信用保障基金，推动企业按照市场化、法治化、国际化的原则，稳妥化解债券违约风险。 上述回复仅供参考。欢迎您再次提问。",
            source: "国资委",
            date: "2021/7/27",
          },
          {
            question:
              "地方的国有资本投资运营集团有限公司拟投资建设城市基础设施项目，应当按照政府投资项目审批，还是按照企业投资项目核准或备案？谢谢答复！",
            answer:
              "您好，根据《政府投资条例》《企业投资项目核准和备案管理条例》等规定，政府采取直接投资或资本金注入方式使用预算安排的资金的项目，为政府投资项目，实行审批制。企业使用自筹资金的项目，以及使用自己筹措的资金并申请使用政府投资补助或贷款贴息的项目为企业投资项目，按照规定进行核准或备案。感谢您对国家发展改革委工作的关心和支持！",
            source: "国家发改委",
            date: "2021/7/21",
          },
        ],
      ],
      newDatas: [],
      shujuDatas: [],
      qiyeDatas: [],
      box2TabData: [
        "最新",
        "数据合规",
        "企业合规",
        // "市场交易",
        // "生态环保",
        // "产品质量",
        // "劳动用工",
        // "财务税收",
        // "知识产权",
        // "商业伙伴",
        // "投资并购",
        // "安全生产",
        // "反商业贿赂",
        // "反垄断",
        // "国有企业",
        // "其他",
      ],
      scrollPosition: 0,
    };
  },
  methods: {
    goback() {
      if (this.fromIndex == 1) {
        this.$router.push({ name: "home" });
      } else {
        this.$router.push({
          name: "home",
          query: { scrollTo: "qa", tab: this.box2TabIndex },
        });
      }
    },
    getParams() {
      if (this.$route.query.tab) {
        this.box2TabIndex = this.$route.query.tab;
      }
      if (this.$route.query.from) {
        this.fromIndex = this.$route.query.from;
      }
      this.getQaDatas();
    },
    chunkArray(array) {
      let index = 0;
      let chunks = [];

      while (index < array.length) {
        chunks.push(array.slice(index, index + 10));
        index += 10;
      }

      return chunks;
    },

    getQaDatas() {
      // this.$router.replace({ name: "qapage" });
      // console.log(this.box2TabIndex);
      this.currentPage = 1;
      var index = "";
      if (this.box2TabIndex == 0) {
        index = "";
      } else if (this.box2TabIndex == 1) {
        index = "1";
      } else if (this.box2TabIndex == 2) {
        index = "2";
      } else {
        index = "";
      }
      fetch(
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getqa" +
          "?tab=" +
          index +
          "&keyWord=" +
          this.searchKeyWords.trim()
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          // console.log(data.data);
          this.totalCount = data.data.length;

          data.data.sort((a, b) => {
            // 使用Date对象将字符串转换为日期
            let dateA = new Date(a.publicTime);
            let dateB = new Date(b.publicTime);

            // 比较两个日期对象
            if (dateA < dateB) {
              return 1;
            }
            if (dateA > dateB) {
              return -1;
            }
            // 如果日期相等，则返回0
            return 0;
          });

          this.listDatas = this.chunkArray(data.data);
          if (this.$route.query.page) {
            this.currentPage = this.$route.query.page;
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    goHangyeDetailPage(item) {
      console.log(item);
      this.$router.push({
        name: "hydetail",
        query: {
          title: item.question,
          author: "答复部门：" + item.source,
          date: "答复时间：" + item.publicTime,
          fulltext: item.answer,
          from: "qa",
          tab: this.box2TabIndex,
          page: this.currentPage,
          index: this.fromIndex,
        },
      });
    },
    formatDate(dateString) {
      var date = "";
      if (dateString === null || dateString === undefined) {
        return;
      } else {
        date = dateString.slice(0, 10);
      }

      // 分割日期字符串
      const parts = date.split("-");

      // 确保年份、月份和日期都是字符串
      const year = parts[0];
      let month = parts[1];
      let day = parts[2];

      // 如果月份或日期小于10，则在前面添加0
      if (month) {
        month = month.length < 2 ? "0" + month : month;
      }
      if (day) {
        day = day.length < 2 ? "0" + day : day;
      }

      // 合并回日期字符串
      return `${year}/${month}/${day}`;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    scrollToTop() {
      // 使用window对象滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动效果
      });
    },
    handleSizeChange() {},
    checkVisibility() {
      // 使用Vue的nextTick确保DOM更新后再进行检查
      this.$nextTick(() => {
        // 更新滚动位置
        this.scrollPosition =
          window.scrollY ||
          window.pageYOffset ||
          document.documentElement.scrollTop;
      });
    },
  },
  computed: {
    isAtTop() {
      return this.scrollPosition >= 500; // 如果滚动距离小于等于500px，则认为在页面最上方
    },
  },
  mounted() {
    // document.querySelector("ecp_top-nav").style.display = "none";

    window.scrollTo(0, 0);
    // 添加滚动事件监听器
    window.addEventListener("scroll", this.checkVisibility);
  },
  beforeUnmount() {
    // 在组件销毁前移除事件监听器
    window.removeEventListener("scroll", this.checkVisibility);
  },
};
</script>

<style scoped lang="scss">
.full {
  width: 100%;
  background: #f4f7fc;
  padding-top: 40px;
  padding-bottom: 40px;

  .box {
    width: 1200px;
    height: auto;
    margin: 40px auto;
    border-radius: 16px;
    background-color: white;
    padding: 40px;
    .menu {
      margin-top: 20px;
      margin-bottom: 12px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tab {
        position: relative;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
        .nav {
          white-space: nowrap;
          overflow: hidden;
          -webkit-overflow-scrolling: touch;
          display: flex;
          gap: 10px;
          justify-content: center;
          width: 100%;
          .tab-item {
            cursor: pointer;
            background: var(--396-f-4-f-5-f-5, #f4f5f5);
            padding: 8px 16px 8px 16px;
            color: #000;
            text-align: center;
            font-size: 14px;
            line-height: 38px; /* 157.143% */
            border-radius: 8px;
          }
          .tab-item:hover {
            border-radius: 8px;
            background: var(--hover-100-eceffa, #eff2ff);
            padding: 8px 16px 8px 16px;
            color: #4175f4;
            text-align: center;
            font-size: 14px;
            line-height: 38px; /* 157.143% */
          }
          .checked {
            color: var(--1100-ffffff, #fff);
            text-align: center;
            padding: 8px 16px 8px 16px;
            font-size: 14px;
            line-height: 38px; /* 157.143% */
            border: 1px solid var(--852-d-53-da, #4175f4);
            background: var(--852-d-53-da, #4175f4);
            border-radius: 8px;
          }
        }
      }
      .input {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 258px;
        height: 32px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        border: 1px solid #e7e9e8;
        padding-left: 10px;
        .edit {
          width: 100%;
          height: 28px;
          border-radius: 8px 0px 0px 8px;
          font-size: 14px;
          padding-left: 6px;
          border: none;
        }
        input[type="text"]:focus {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          outline: none;
        }
        .btn {
          cursor: pointer;
          margin-left: 5px;
          margin-right: 6px;
          width: 24px;
          height: 24px;
          background: #eff2ff;
          border-radius: 16px 16px 16px 16px;
          img {
            margin-left: 5px;
            margin-top: 4px;
          }
        }
      }
    }

    .item {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: top;
      padding: 12px;
      width: 100%;
      .leftbox {
        .q {
          max-width: 950px;
          font-size: 18px;
          color: #262626;
          word-break: break-all;
          font-weight: 550;
        }
        .source {
          margin-top: 12px;
          margin-bottom: 12px;
          font-size: 16px;
          color: #7e7e7e;
        }
      }
      .rightbox {
        min-width: 150px;
        color: #8a8f8d;
      }
    }

    .item:hover {
      .q {
        color: #4175f4;
      }
    }
  }
}
.back {
  cursor: pointer;
  position: absolute;
  top: 100px;
  left: 0;
  width: 88px;
  height: 38px;
  background: #ffffff;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
    0px 0px 14px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 8px 8px 0px;
  font-size: 14px;
  color: #262626;
  line-height: 38px;
  text-align: center;
}
.back:hover {
  color: #4175f4;
}

.back-to-top {
  position: fixed;
  right: 50px; /* 距离右侧的距离 */
  bottom: 100px; /* 距离底部的距离 */
  width: 100px; /* 你可以根据需要调整 */
  height: 50px; /* 你可以根据需要调整 */
  background-color: #4175f4; /* 你可以根据需要调整 */
  color: #fff;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px; /* 如果你使用的是文本而不是图标 */
  cursor: pointer;
  opacity: 0.3; /* 透明度 */
  transition: opacity 0.3s ease; /* 平滑过渡效果 */
}

.back-to-top:hover {
  opacity: 0.7; /* 鼠标悬停时增加透明度 */
}

.fanye {
  width: 452px;
  height: 32px;
  border-radius: 0px 0px 0px 0px;
  margin: 0 auto;
}
</style>